"use strict";
(() => {
    const countdownElements = document.querySelectorAll('[data-timer-date]');
    if (!countdownElements.length)
        return;
    const search = new URLSearchParams(window.location.search);
    countdownElements.forEach((element) => {
        const timerDate = element.getAttribute('data-timer-date');
        const expiresParam = search.get('expires');
        if (timerDate === 'expires' && expiresParam) {
            element.addEventListener('theme:timer:expired', () => {
                const headlineElement = element.querySelector('[data-timer-headline]');
                if (headlineElement && headlineElement.hasAttribute('data-timer-expired')) {
                    headlineElement.innerText = headlineElement.getAttribute('data-timer-expired') || '';
                }
            });
            element.setAttribute('data-timer-date', expiresParam);
            const countdownContainer = element.closest('.Countdown');
            if (countdownContainer) {
                countdownContainer.classList.remove('none');
            }
            const timerLabel = element.querySelector('.Timer__Label');
            if (timerLabel) {
                const expireDate = new Date(expiresParam);
                const formattedDate = expireDate.toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                });
                const formattedTime = element.getAttribute('data-timer-time') || '00:00';
                timerLabel.innerHTML = timerLabel.innerHTML
                    .replace('--.--.----', formattedDate)
                    .replace('--:--', formattedTime);
            }
            element.dispatchEvent(new CustomEvent('theme:timer:init', { bubbles: true }));
        }
    });
})();
